import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "windows",
  "use": "windows-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1000 1000\" id=\"windows\">\n<path d=\"M982.7,987.5l-516.9-72.8v0L17.5,853.3V473.9l0.2,0l-0.4-325.2l448.5-61v0.1l517-75.2v461.8h0.1L982.7,987.5z M465.9,855.5\n\tL924,920l0.1-387.1l-458.6-0.8l0.1,158.4L465.9,855.5z M76.1,802.1L407,847.4l-0.1-156.8l-0.3-155.6l-330.5-2.2V802.1z M465.9,147\n\tv326.1l458.1-3.6V80.3L465.9,147z M76,199.9l0.3,268.8l330.9-1.9l-0.2-311.9L76,199.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol